import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Products from '../components/Products'

export default function Home() {
  const { t } = useTranslation()

  const testimonials = [
    {
      id: 1,
      name: t('home.testimonials.client1.name'),
      business: t('home.testimonials.client1.business'),
      quote: t('home.testimonials.client1.quote'),
      image: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-2.jpg"
    },
    {
      id: 2,
      name: t('home.testimonials.client2.name'),
      business: t('home.testimonials.client2.business'),
      quote: t('home.testimonials.client2.quote'),
      image: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-3.jpg"
    },
    {
      id: 3,
      name: t('home.testimonials.client3.name'),
      business: t('home.testimonials.client3.business'),
      quote: t('home.testimonials.client3.quote'),
      image: "https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-4.jpg"
    }
  ]

  const processSteps = [
    {
      id: 1,
      title: t('home.process.step1.title'),
      description: t('home.process.step1.description')
    },
    {
      id: 2,
      title: t('home.process.step2.title'),
      description: t('home.process.step2.description')
    },
    {
      id: 3,
      title: t('home.process.step3.title'),
      description: t('home.process.step3.description')
    },
    {
      id: 4,
      title: t('home.process.step4.title'),
      description: t('home.process.step4.description')
    }
  ]

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section
        className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://ozhkjwcjsifdhfdexayd.supabase.co/storage/v1/object/public/website-images/projects/1763352751384_x4pcvj25/image-4.jpg')`,
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="container mx-auto px-4 md:px-8 lg:px-12 text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl">
            {t('home.hero.title')}
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed drop-shadow-lg">
            {t('home.hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="#products"
              onClick={(e) => {
                e.preventDefault()
                document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })
              }}
              className="group w-full sm:w-auto px-10 py-4 bg-[#E2725B] hover:bg-[#d65f48] text-white text-lg font-bold rounded-xl transition-all duration-300 flex items-center justify-center shadow-2xl hover:shadow-[#E2725B]/50 hover:scale-105 transform cursor-pointer"
            >
              <span>{t('home.hero.cta')}</span>
              <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
            <Link
              to="/about"
              className="group w-full sm:w-auto px-10 py-4 bg-white/15 backdrop-blur-md hover:bg-white/25 text-white text-lg font-bold rounded-xl transition-all duration-300 flex items-center justify-center border-2 border-white/80 hover:border-white shadow-xl hover:scale-105 transform"
            >
              <span>{t('home.hero.secondaryCta')}</span>
            </Link>
          </div>

          {/* Trust Indicator */}
          <div className="mt-12 flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 inline-flex mx-auto">
            <div className="flex -space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <svg key={star} className="w-6 h-6 drop-shadow-lg text-[#FFDB58]" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
            <p className="text-white font-semibold text-sm md:text-base">
              {t('home.hero.trust')}
            </p>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <div id="products">
        <Products />
      </div>

      {/* Process Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-4">
              {t('home.process.title')}
            </h2>
            <p className="text-base md:text-lg text-[#333333]/70 max-w-2xl mx-auto">
              {t('home.process.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {processSteps.map((step, index) => (
              <div
                key={step.id}
                className="relative bg-white rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-[#FFDB58]/20 hover:border-[#E2725B]/40"
              >
                {/* Step Number */}
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-[#E2725B] text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                  {index + 1}
                </div>

                {/* Content */}
                <h3 className="text-xl md:text-2xl font-bold text-[#333333] mb-3 text-center mt-4">
                  {step.title}
                </h3>
                <p className="text-base text-[#333333]/70 text-center leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-[#FFDB58]/10 to-[#E2725B]/10">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#333333] mb-4">
              {t('home.testimonials.title')}
            </h2>
            <p className="text-base md:text-lg text-[#333333]/70 max-w-2xl mx-auto">
              {t('home.testimonials.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-white rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <svg key={star} className="w-5 h-5 text-[#FFDB58]" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

                {/* Quote */}
                <p className="text-base md:text-lg text-[#333333]/80 mb-6 leading-relaxed italic">
                  "{testimonial.quote}"
                </p>

                {/* Client Info */}
                <div className="flex items-center gap-4 pt-4 border-t-2 border-[#FFDB58]/30">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover"
                    crossOrigin="anonymous"
                  />
                  <div>
                    <h4 className="font-bold text-[#333333] text-base md:text-lg">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-[#333333]/60">
                      {testimonial.business}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 lg:py-28 bg-gradient-to-r from-[#E2725B] to-[#E2725B]/90">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              {t('home.cta.title')}
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
              {t('home.cta.subtitle')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/products"
                className="group w-full sm:w-auto px-10 py-4 bg-white text-[#E2725B] hover:bg-[#FFDB58] hover:text-[#333333] text-lg font-bold rounded-xl transition-all duration-300 flex items-center justify-center shadow-2xl hover:shadow-[#FFDB58]/50 hover:scale-105 transform"
              >
                <span>{t('home.cta.secondaryButton')}</span>
                <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
              <Link
                to="/contact"
                className="group w-full sm:w-auto px-10 py-4 bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E2725B] text-lg font-bold rounded-xl transition-all duration-300 flex items-center justify-center shadow-xl hover:scale-105 transform"
              >
                <span>{t('home.cta.button')}</span>
              </Link>
            </div>

            {/* Trust Badges */}
            <div className="mt-12 flex flex-wrap justify-center items-center gap-6 md:gap-8">
              <div className="flex items-center gap-2 text-white/90">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span className="text-sm md:text-base font-medium">{t('home.cta.badge1')}</span>
              </div>
              <div className="flex items-center gap-2 text-white/90">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm md:text-base font-medium">{t('home.cta.badge2')}</span>
              </div>
              <div className="flex items-center gap-2 text-white/90">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <span className="text-sm md:text-base font-medium">{t('home.cta.badge3')}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
